import CantileverCard from 'components/CantileverCard'
import { WalkdownUnitList } from 'features/walkdowns'
import React from 'react'
import { GeckoUnit, GeckoWalkdown } from 'types'

interface WalkdownUnitsProps {
  walkdown: GeckoWalkdown
  units: readonly GeckoUnit[]
}

export const WalkdownUnitsAccordion: React.FC<WalkdownUnitsProps> = ({
  walkdown,
  units,
}) => {
  if (!walkdown) {
    return null
  }

  return (
    <CantileverCard>
      <CantileverCard.CardHeader leadingContent='Units' />
      <CantileverCard.Section topPadding>
        <CantileverCard.Group>
          <WalkdownUnitList units={units} />
        </CantileverCard.Group>
      </CantileverCard.Section>
    </CantileverCard>
  )
}
